import script from "./TableHeaderItemWithSort.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableHeaderItemWithSort.vue?vue&type=script&setup=true&lang=ts"

import "./TableHeaderItemWithSort.vue?vue&type=style&index=0&id=56fe7c60&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56fe7c60"]])

export default __exports__